module.exports = __webpack_public_path__ + "img/cmp-tab-inactive-version.e99f4059.svg";